import { SparklineContainer, StyledPlusIconDiv, WidgetEdit, WidgetOverlay, WidgetWrapStyle } from "./styles";
import { getIcon, trendIconSelect } from "../../global/utility/statisticsUtil";
import { Box, Stack } from "@mui/material";
import { SparkLineChart } from "@mui/x-charts";
import { ReactComponent as LocationAlt } from "../../assets/location-alt.svg";
import { Icon } from "@vds/icons";
import AddWidgetModal from "./AddWidgetModal";
import { useSelector } from "react-redux";
import { useState } from "react";
import { formatTimerValue } from "../../global/utility/Utils";

const EmptyWidget = ({index}) => {
    const [showModal, setShowModal] = useState(false);
    const cvAppConfiged = useSelector((state) => state.polygonRoiReducer.roiListWithCvapps);
    const selectedTimerData = useSelector((state) => state.widgetReducer.selectedTimerValue);
    const widgetAdded = () => {
        setShowModal(false);
    }
    const formattedTimerValue = formatTimerValue(selectedTimerData);

    return (
        <>
        {<AddWidgetModal  showModal={showModal} setShowModal={setShowModal} index={index} widgetAdded={widgetAdded} cvAppConfigedList = {cvAppConfiged}/>}
        <div style={{position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 2}}>
                <StyledPlusIconDiv data-testid="dashboard_emptyWidgetAddButton" onClick={() => {
                    setShowModal(true)}}>
                    <Icon name="plus" size="medium" color="#000000" />
                </StyledPlusIconDiv> 
            </div>
        <WidgetOverlay/>
        <WidgetWrapStyle>
        <div className="appInfoWrap">
            <div style={{ display: "flex", marginTop: "4px" }}>
            <div style={{ margin: "-2px 7px 0 0" }}>
                {" "}
                <LocationAlt size="small" />{" "}
            </div>
            </div>
        </div>
        <div className="statisticsDataWraps" style={{display: "flex", justifyContent: "space-between"}}>
            <div className="statisticData">
            <div className="lastUpdatedText">{formattedTimerValue !== "" ? formattedTimerValue + ".": "Last 10 min."}</div>
            <div style={{ display: "flex", marginTop: "8px" }}>
                {(
                <div style={{ marginRight: "16px" }}>
                    <div className="dynamicDataInfo"> total </div>
                </div>
                )}
                <div
                style={{
                    borderLeft: "2px solid #D8DADA",
                    paddingLeft: "8px",
                }}
                >
                <div style={{ display: "flex" }}>
                    {trendIconSelect(0)}
                </div>
                </div>
            </div>
            </div>
            <SparklineContainer>
            <Stack direction="row" sx={{ width: "auto" }}>
                <Box sx={{ flexGrow: 1 }}>
                <SparkLineChart
                    data={[0,0,0,0,0,0,0,0,0,0,0,0,4]}
                    height={40}
                    colors={["#0089EC"]}
                />
                </Box>
            </Stack>
            </SparklineContainer>
        </div>
        </WidgetWrapStyle>
        </>
    )
}

export default EmptyWidget;